import { configureStore } from '@reduxjs/toolkit';

import userReducer from '../features/user/userSlice';
import poisReducer from '../features/pois/poisSlice';
import languageReducer from '../features/language/languageSlice';
import newsReducer from '../features/news/newsSlice';
import mapReducer from '../features/map/mapSlice';
import galleryReducer from '../features/gallery/gallerySlice';
import reviewsReducer from '../features/reviews/reviewsSlice';
import { combineReducers } from 'redux';
import { setCardNumber } from '../api/mobile';

const appReducer = combineReducers({
    user: userReducer,
    pois: poisReducer,
    language: languageReducer,
    news: newsReducer,
    map: mapReducer,
    gallery: galleryReducer,
    reviews: reviewsReducer
});

const rootReducer = (state, action) => {
  if (action.type === 'user/loggedOut') {
    setCardNumber(null);
    localStorage.clear();
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};


export default configureStore({
    reducer: rootReducer
})